import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_REQUIREMENTS_BY_CLASS_ID = gql`
  query GetViewedRequirementsByClassId($classId: Int!) {
      getViewedRequirements(schoolClassID: $classId) {
        id
        requirementName
        value
      }
    }
`;
